module.exports = __webpack_public_path__ + "8e37e5d83579596d2ae5891992153b4b.svg";